module.exports = __webpack_public_path__ + "media/squish.b0a38491.webm";